import { Box, useTheme } from "@mui/material"
import { useEffect } from "react";
import ServicedeskLabels from "./settings/ServicedeskLabels";
import { warehouseRelationServiceSettingsConfig } from "./settings/warehouseRelationServiceSettingsConfig";
import { useTranslation } from "react-i18next";
import { tokens } from "../../../../../theme";
import TabView3 from "../../../../../components/theme/TabView3/TabView3";

const ServicedeskSettings = (props) => {
    const { t } = useTranslation();
    
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);


    useEffect(() => {
        props.replaceView({
            ...props.config,
        });
    }, []);

    return (
        <Box
            sx={{
                padding:"0px 32px",
                paddingTop:"32px",
                height:1,
                "@media screen and (max-width: 47.9375em)" : {
                    paddingTop:0,
                    paddingX:0,
                }
            }}
        >
            <TabView3
                tabConfig={warehouseRelationServiceSettingsConfig}
                viewType="bodytabs"
                sx={{
                    position:"relative",
                    zIndex:2,
                    display: "flex",
                    flex:1,
                    height:1,
                    "@media screen and (max-width: 47.9375em)" : {
                        "&:before" : {
                            content: "''",
                            display:"block",
                            position:"absolute",
                            left:0,
                            top:0,
                            zIndex:1,
                            backgroundColor: `${theme.palette.mode === "dark" ? colors.grey[200] : colors.grey[0]}`,
                            height:"48px",
                            width:"24px",
                            borderTopLeftRadius:"24px",
                            boxShadow: `0 -24px 0 0 ${colors.bg["tertiary"]}`,
                            // transition:"250ms"
                        },
        
                        "&:after" : {
                            content: "''",
                            display:"block",
                            position:"absolute",
                            top:0,
                            zIndex:1,
                            backgroundColor: `${theme.palette.mode === "dark" ? colors.grey[200] : colors.grey[0]}`,
                            right:0,
                            height:"48px",
                            width:"24px",
                            borderTopLeftRadius:"24px",
                            boxShadow: `0 -24px 0 0 ${colors.bg["tertiary"]}`,
                            transform:"scaleX(-1)",
                            // transition:"250ms"
                        },
                    }
                  
                }}
                tabClasses={"btn-body-tab"}
            >
                <>
                    <ServicedeskLabels config={warehouseRelationServiceSettingsConfig.labels} />
                </>
            </TabView3>
        </Box>
    )
}

export default ServicedeskSettings